import { call, put, takeLatest } from "redux-saga/effects";
import {
  EXECUTE_AURORA_SQL_REQUEST,
  GET_QUERY_BUILDER_SCHEMA_REQUEST,
  executeAuroraSqlSuccess,
  executeAuroraSqlFailure,
  getQueryBuilderSchemaSuccess,
  getQueryBuilderSchemaFailure,
} from "../actions/auroraSqlActions";
import {
  executeAuroraSqlFromApi,
  getQueryBuilderSchemaFromApi,
} from "../apis/auroraSqlApi";

// Execute Dynamic Query (Aurora SQL) Saga
function* executeAuroraSqlSaga(action) {
  try {
    console.log("Aurora SQL Saga - executeAuroraSqlSaga - action:", action);

    const response = yield call(executeAuroraSqlFromApi, action.payload);

    console.log("Aurora SQL Saga - executeAuroraSqlSaga - response:", response);

    if (response && response.success) {
      yield put(executeAuroraSqlSuccess(response));
    } else {
      yield put(executeAuroraSqlFailure(response?.error || "Execution failed"));
    }
  } catch (error) {
    console.error("Aurora SQL Saga - executeAuroraSqlSaga - error:", error);
    yield put(executeAuroraSqlFailure(error.message));
  }
}

// Get Query Builder Schema Saga
function* getQueryBuilderSchemaSaga() {
  try {
    console.log("Aurora SQL Saga - getQueryBuilderSchemaSaga");

    const response = yield call(getQueryBuilderSchemaFromApi);

    console.log(
      "Aurora SQL Saga - getQueryBuilderSchemaSaga - response:",
      response
    );

    if (response) {
      yield put(getQueryBuilderSchemaSuccess(response));
    } else {
      yield put(getQueryBuilderSchemaFailure("Schema fetch failed"));
    }
  } catch (error) {
    console.error(
      "Aurora SQL Saga - getQueryBuilderSchemaSaga - error:",
      error
    );
    yield put(getQueryBuilderSchemaFailure(error.message));
  }
}

// Aurora SQL Saga Watcher
export function* auroraSqlSaga() {
  yield takeLatest(EXECUTE_AURORA_SQL_REQUEST, executeAuroraSqlSaga);
  yield takeLatest(GET_QUERY_BUILDER_SCHEMA_REQUEST, getQueryBuilderSchemaSaga);
}
